'use client';
import React from 'react';
import { TextVariants } from '~/theme/text-styles';
import styles from './Text.module.scss';
import clsx from 'clsx';
import { TypographyTag } from '../Typography/Typography';

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
    variant?: TextVariants;
    color?: string;
    as?: TypographyTag;
}

export const Text = ({
    variant,
    as = 'p',
    children,
    color,
    style,
    className,
    ...rest
}: TextProps) => {
    const Tag = as;

    return (
        <Tag
            className={clsx(styles.component, styles[variant ?? ''], className)}
            style={
                {
                    ...style,
                    '--textColor': color ? `#${color?.replace(/#/g, '')}` : '#231f20',
                } as React.CSSProperties
            }
            {...rest}
        >
            {children}
        </Tag>
    );
};
